import { styled } from '@mui/material/styles';
import { Divider, Typography } from '@mui/material';
import DeviceIcon from '#component/icon/device-icon';

export const TooltipContainer = styled('div')({
  textAlign: 'left',
  minWidth: 150
});

export const Header = styled(Typography)({
  whiteSpace: 'nowrap',
  display: 'flex',
  marginLeft: '-4px',
  marginBottom: '8px',
  '& svg': {
    marginRight: 4
  }
});

export const AlertHeader = styled(Header)({
  color: '#f77061'
});

export const Label = styled('div')(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(1),
  marginLeft: '-4px',
  '& p': {
    lineHeight: '26px',
    color: theme.palette.common.white
  }
}));

export const StyledDeviceIcon = styled(DeviceIcon)(({ theme }) => ({
  marginRight: 4,
  color: `${theme.palette.common.white} !important`
}));

export const TimestampCnt = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white
}));

export const LocatedTimestampCnt = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  whiteSpace: 'nowrap',
  margin: '8px 4px'
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: '4px !important',
  marginBottom: '4px !important',
  // on device overview page `<style ... data-meta="MuiDivider">` placed after component styles
  // and overrides it
  backgroundColor: `${theme.palette.common.white} !important`
}));

export const TempCnt = styled(Typography, {
  shouldForwardProp: prop => !['alert', 'isLight', 'isPressure'].includes(prop)
})(({ alert, isLight, isPressure }) => ({
  display: 'inline-box',
  marginRight: 12,
  marginTop: 6,
  '& svg': {
    verticalAlign: 'bottom',
    ...(isLight && { marginRight: 4 }),
    ...(isPressure && { marginRight: 1 })
  },
  '& > div': {
    display: 'block'
  },
  ...(alert && { color: '#f77061' })
}));
